export default __webpack_public_path__ + "static/media/O-079.93034a05.png";